import { send } from '@mycrypto/eth-scan';
export const getBlock = (provider, blockNumber) => send(provider, 'eth_getBlockByNumber', [blockNumber, false]);
export const getLatestBlock = provider => getBlock(provider, 'latest');
export const getFeeHistory = (provider, blockCount, newestBlock, rewardPercentiles) => send(provider, 'eth_feeHistory', [blockCount, newestBlock, rewardPercentiles !== null && rewardPercentiles !== void 0 ? rewardPercentiles : []]);
